import { DateChanger } from '@/components/Header/Datechanger'
import { type View } from '@/types/index'
import { PersonalAssignmentsFilter } from './PersonalAssignmentsFilter'
import { useMemo, type JSX } from 'react'
import { AddButtonGroup } from './AddButtonGroup'
import { useQuery } from '@/hooks/useQuery'

export const Header = ({ assigneeId, type, docType }: {
  type: View
  assigneeId?: string | undefined
  docType?: string
}): JSX.Element => {
  const [query] = useQuery()
  const showButton = useMemo(() => {
    const viewTypes: View[] = ['Planning', 'Event', 'Factbox', 'Approvals', 'Assignments', 'Timeless']
    if (viewTypes.includes(type)) {
      return true
    }
    return false
  }, [type])

  return (
    <>
      {showButton && (
        <AddButtonGroup type={type} docType={docType} query={query} />
      )}

      <DateChanger type={type} />

      {type === 'Assignments'
        && <PersonalAssignmentsFilter assigneeId={assigneeId} />}
    </>
  )
}
